// File: fbMdbAuthBase-100824/client/src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import financialReducer from '../features/financial/financialSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    financial: financialReducer,
  },
});